import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/repo/src/app/(services)/resume-writing/resumeWritingPage.tsx");
